<template>
  <span ref="el">
    <font-awesome-icon icon="circle-info" class="icon float-end mt-2" style="color: #0fb9b9" />
  </span>
</template>

<script>
import { Popover as BootstrapPopover } from 'bootstrap';

export default {
  name: 'Popover',
  props: ['content', 'placement', 'trigger'],
  data() {
    return {
      el: null,
    };
  },
  mounted() {
    if (this.content) {
      this.el = new BootstrapPopover(this.$refs.el, {
        container: 'body',
        html: true,
        trigger: this.trigger ?? 'hover click focus',
        placement: this.placement ?? 'bottom',
        content: this.content ?? ' ',
      });
    }
  },
  unmounted() {
    if (this.el) {
      this.el.dispose();
    }
  },
};
</script>

<style scoped>
.icon {
  font-size: 80%;
}
</style>
